var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle",style:(_vm.styleVar),domProps:{"innerHTML":_vm._s(_vm.dataItem.title)}})
}
var staticRenderFns = []

export { render, staticRenderFns }